export default {
  primaryColor: '#911448',
  disabledPrimaryColor: '#cacaca',
  primaryColorDark: '#231d45',
  textColor: '#231d45'
}
